import { render, staticRenderFns } from "./Vedit.vue?vue&type=template&id=40730337&"
import script from "./Vedit.vue?vue&type=script&lang=js&"
export * from "./Vedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports